/**
 * Parse Shopify metafield rich_text_field into display segments.
 * Returns null on missing/invalid data so callers can fall back to plain title.
 */
export const parseRichTitle = (richTitle) => {
  if (!richTitle?.value) {
    return null;
  }

  try {
    const doc = JSON.parse(richTitle.value);
    if (!doc || doc.type !== "root" || !Array.isArray(doc.children)) {
      return null;
    }

    const segments = [];

    const walk = (nodes) => {
      if (!Array.isArray(nodes)) return;
      nodes.forEach((node) => {
        if (!node) return;
        if (node.type === "text" && typeof node.value === "string") {
          // Skip empty text nodes so blank rich titles fall back to default
          if (node.value.length === 0) return;
          segments.push({
            text: node.value,
            bold: Boolean(node.bold),
            italic: Boolean(node.italic),
          });
          return;
        }
        if (Array.isArray(node.children)) {
          walk(node.children);
        }
      });
    };

    walk(doc.children);

    const hasVisibleText = segments.some((s) => s.text.trim().length > 0);
    return hasVisibleText ? segments : null;
  } catch {
    return null;
  }
};
